var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallboy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 168,
    viewBox: "0 0 156 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.797 34.8529C158.079 45.4468 157.025 64.3949 153.226 79.5957C149.386 94.8348 142.761 106.373 133.478 120.147C124.196 133.922 112.264 149.967 96.4734 153.676C80.6824 157.386 61.1114 148.718 43.8967 134.943C26.6819 121.168 11.7838 102.209 7.81887 79.4733C3.8566 56.6937 10.7721 30.0853 27.9895 19.4914C45.2069 8.89749 72.7579 14.3156 96.3466 18.1471C119.89 22.0168 139.512 24.259 148.797 34.8529Z",
    fill: "black",
    fillOpacity: 0.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1616 51.4492C74.8023 53.1456 75.1933 65.2904 74.6729 67.2061C74.1525 69.1219 68.3782 92.534 68.3782 92.534L77.5627 90.0826C77.5627 90.0826 80.7827 83.2488 81.9503 77.096C82.9778 71.6804 82.8299 51.5436 75.1616 51.4492Z",
    fill: "#D18C65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2466 56.8112H60.2873L56.8745 44.3118H62.8364L66.2466 56.8112Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.421 91.5673H78.6748V154.092H143.421V91.5673Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6647 110.344C94.2681 110.344 97.1892 107.523 97.1892 104.044C97.1892 100.564 94.2681 97.7429 90.6647 97.7429C87.0613 97.7429 84.1401 100.564 84.1401 104.044C84.1401 107.523 87.0613 110.344 90.6647 110.344Z",
    fill: "#A4A4A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.673 101.342H135.753",
    stroke: "white",
    strokeWidth: 2.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.673 106.743H117.339",
    stroke: "white",
    strokeWidth: 2.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.673 120.13H135.753",
    stroke: "white",
    strokeWidth: 2.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.673 125.53H117.339",
    stroke: "white",
    strokeWidth: 2.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.673 138.915H135.753",
    stroke: "white",
    strokeWidth: 2.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.673 144.315H117.339",
    stroke: "white",
    strokeWidth: 2.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6647 129.129C94.2681 129.129 97.1892 126.308 97.1892 122.829C97.1892 119.349 94.2681 116.528 90.6647 116.528C87.0613 116.528 84.1401 119.349 84.1401 122.829C84.1401 126.308 87.0613 129.129 90.6647 129.129Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6647 147.917C94.2681 147.917 97.1892 145.096 97.1892 141.616C97.1892 138.136 94.2681 135.315 90.6647 135.315C87.0613 135.315 84.1401 138.136 84.1401 141.616C84.1401 145.096 87.0613 147.917 90.6647 147.917Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8608 150.391L22.9495 147.006L26.8009 153.817L19.7084 157.199L16.8608 150.391Z",
    fill: "#E49D75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5315 147.006L62.8892 154.534L71.1228 153.182L68.4074 144.639L61.5315 147.006Z",
    fill: "#E49D75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.908 87.0496C79.4831 87.1771 39.694 95.5211 39.1762 97.4777C34.9155 113.528 59.2517 147.22 61.04 148.241C62.9684 147.792 69.5484 145.577 69.5484 145.577L68.0374 123.112L81.908 87.0496Z",
    fill: "#E5B800"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5019 158.256L16.6415 148.445L3.41548 136.223L0 138.04L13.094 162.273L21.5019 158.256Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7461 152.809L60.657 154.717L44.9294 163.765L45.8355 167.431L73.5133 161.707L71.7461 152.809Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.602 77.0959C114.15 78.2923 115.772 83.6849 115.96 85.5139C117.986 106.732 81.8209 119.227 76.8126 121.323C72.0578 125.163 30.586 154.687 28.0581 155.386C25.5302 156.085 21.3962 146.713 21.7581 145.46C22.12 144.208 82.9039 85.2002 82.9039 85.2002L112.602 77.0959Z",
    fill: "#FFCC00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5222 38.9013C78.4055 36.46 73.6746 49.8497 74.1289 51.3828C74.5832 52.9159 79.2799 53.3547 80.4686 53.3547C81.6572 53.3547 83.5222 38.9013 83.5222 38.9013Z",
    fill: "#2B45D4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3326 31.2205C112.008 31.2205 113.77 74.2159 113.559 77.1495C111.673 83.1288 89.0508 90.3121 82.0877 86.3812C71.0383 61.3619 76.1285 31.2205 93.3326 31.2205Z",
    fill: "#FFCC00",
    fillOpacity: 0.08
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.963 52.4185C113.007 54.1378 115.252 65.3413 115.028 66.803C114.803 68.2647 111.329 71.9533 110.093 72.0349C92.5166 73.1879 73.4528 66.4051 69.8894 64.4995C62.435 63.9256 58.0237 61.3262 58.0237 57.5254C58.0237 55.2806 59.3127 53.6633 60.0233 53.6633C61.3705 53.6633 63.7637 55.9055 64.0543 56.5611C63.4731 55.4081 61.6505 53.2909 63.1509 53.2909C63.5682 53.2909 66.9546 57.8621 68.7931 58.9717C70.6316 60.0814 97.1657 61.0124 102.486 62.8797C101.807 61.5736 99.9049 56.8392 99.8732 56.1555C99.8415 55.4719 111.963 52.4185 111.963 52.4185Z",
    fill: "#E49D75"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1348 23.9507L50.1963 25.858C49.0974 26.0689 48.3836 27.1002 48.602 28.1614L50.5771 37.759C50.7955 38.8202 51.8633 39.5095 52.9623 39.2986L62.9008 37.3913C63.9997 37.1804 64.7135 36.1491 64.4951 35.0879L62.52 25.4903C62.3016 24.4291 61.2337 23.7398 60.1348 23.9507Z",
    fill: "#2B45D4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5835 41.493L59.8197 37.9779L56.0476 38.7024L58.5835 41.493Z",
    fill: "#2B45D4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7027 34.6464C106.788 31.7843 113.181 49.8242 112.919 52.1098C112.658 54.3955 99.7118 58.3978 98.2537 57.5713C96.7955 56.7448 90.6884 37.483 98.7027 34.6464Z",
    fill: "#3453FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M93.861 23.3969C93.7738 24.481 94.458 30.5394 95.5278 32.5163C95.0549 33.4142 90.1945 36.0238 87.8674 35.4652C87.5504 33.7867 86.7077 29.2792 86.0183 27.9068C87.2625 27.2793 93.861 23.3969 93.861 23.3969Z",
    fill: "#D18C65"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8885 28.6561C93.5486 27.2058 96.6111 20.4765 94.7288 13.6257C92.8465 6.77498 86.7322 2.39703 81.0722 3.84731C75.4121 5.29758 72.3496 12.0269 74.2319 18.8776C76.1142 25.7284 82.2285 30.1063 87.8885 28.6561Z",
    fill: "#E49D75"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4603 16.0834C88.8739 16.1141 86.6365 15.0121 86.1399 11.7061C84.5259 11.451 77.4097 12.1831 73.6798 15.0223C72.2983 15.5324 71.1783 15.9584 69.0889 15.9584C68.0983 15.9584 67.2583 14.9585 67.2583 14.2723C67.2583 12.3821 68.0983 10.5505 70.5523 10.4281C68.4866 10.3847 66.5715 9.15264 66.5715 8.24452C66.5715 7.03794 69.4112 3.33658 74.364 4.95896C73.2017 4.14777 71.8889 3.35699 71.8889 2.58917C71.8889 1.27545 73.8463 0 77.2697 0C82.5659 0 88.3376 2.1198 89.5844 3.63759C90.1656 3.34678 90.9052 2.80599 92.321 2.80599C95.8501 2.80599 97.0335 13.8463 95.5067 17.5477C95.1286 17.7822 94.7055 17.941 94.2625 18.0145",
    fill: "#E5B800"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3545 16.3257C89.5296 15.8444 89.8521 15.4257 90.2791 15.1253C90.7062 14.8249 91.2176 14.6568 91.7458 14.6434C92.274 14.63 92.7939 14.7719 93.2367 15.0503C93.6794 15.3286 94.0242 15.7303 94.2253 16.2022C94.4263 16.674 94.4742 17.1937 94.3626 17.6924C94.2509 18.1911 93.985 18.6452 93.6 18.9947C93.2151 19.3442 92.7293 19.5725 92.207 19.6493C91.6847 19.7262 91.1505 19.648 90.6752 19.4251",
    fill: "#E49D75"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallboy);
export default __webpack_public_path__ + "static/media/smallboy.1dc90496faea68d81db87b53ca38f938.svg";
export { ForwardRef as ReactComponent };